module.exports = __webpack_public_path__ + "media/noBargaining2.9a2ed48e.mp3";